import { SettingUrls } from 'constants/SettingsUrls';
import { PackageProviderName } from 'data/ppoints/constants';
import { Provider } from 'models/Provider';

/** Query param `OrdersPage` reads to preselect a provider */
export const ORDERS_PROVIDER_PARAM = 'provider';

/** The orders page, optionally opened on one provider's orders */
export const ordersUrl = (provider?: PackageProviderName | Provider): string =>
    provider
        ? `${SettingUrls.orders}?${new URLSearchParams({ [ORDERS_PROVIDER_PARAM]: provider })}`
        : SettingUrls.orders;
